import { inject, Injectable } from "@angular/core";
import { TemplateService } from "@domain/project/template/template.service";
import { BusinessScope } from "@lib/constants/business-scope";
import { map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GlobalFloorplanService {
  private templateService: TemplateService = inject(TemplateService);

  getFloorplanTags(scope: BusinessScope) {
    return this.templateService.getGlobalTemplate(scope).pipe(
      map((template) => {
        return template!.properties!.project!.floorplans!.tags ?? [];
      }),
    );
  }
}
